import { Helmet } from 'react-helmet-async';
import { filter } from 'lodash';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { styled } from '@mui/material/styles';
// @mui
import {
  Card,
  Table,
  Stack,
  Paper,
  Avatar,
  Button,
  Switch,
  Popover,
  Checkbox,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel,
} from '@mui/material';
// components
import Iconify from '../components/iconify';
import Scrollbar from '../components/scrollbar';
// sections
import { UserListHead } from '../sections/@dashboard/user';
import HunterForDog from '../components/HunterForDog';

// Stranica sa pregledom pretplatnika; ?vlasnik=ID filtrira tabelu i otvara kerove tog vlasnika
const VLASNIK_URL = '/dashboard/HuntersReportAll';

const TABLE_HEAD = [
  { id: 'id', label: 'Broj', alignRight: false },
  { id: 'tip', label: 'Tip', alignRight: false },
  { id: 'subscriber', label: 'Vlasnik', alignRight: false, sortable: false },
  { id: 'ime', label: 'Ime', alignRight: false },
  { id: 'tiptrackera', label: 'Tip trackera', alignRight: false },
  { id: 'IMEI', label: 'IMEI', alignRight: false },
  { id: 'aktivan', label: 'Aktivan', alignRight: false },
  { id: 'online', label: 'Online', alignRight: false },
  { id: 'onlinetoday', label: 'Online danas', alignRight: false },
  { id: 'datumlast', label: 'Datum last', alignRight: false },
  { id: 'datumend', label: 'Datum end', alignRight: false },
  { id: 'saldo', label: 'Saldo', alignRight: false },
  { id: 'update', label: 'Update', alignRight: false, sortable: false },
  { id: 'share', label: 'Share', alignRight: false, sortable: false },
  { id: 'transfer', label: 'Transfer', alignRight: false, sortable: false },
  { id: 'delete', label: 'Delete', alignRight: false, sortable: false },
];

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  const sorted = stabilizedThis.map((el) => el[0]);
  if (query) {
    return filter(sorted, (_user) => _user.ime.toLowerCase().indexOf(query.toLowerCase()) !== -1);
  }
  return sorted;
}

function useForceUpdate() {
  const [value, setValue] = useState(0); // integer state
  return () => setValue((value) => value + 1); // update state to force render
}

// Stilizovani switch za Online / Online danas (definisan jednom, izvan komponente)
const Android12Switch = styled(Switch)(({ theme }) => ({
  padding: 8,
  '& .MuiSwitch-track': {
    borderRadius: 22 / 2,
    '&:before, &:after': {
      content: '""',
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)',
      width: 16,
      height: 16,
    },
    '&:before': {
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
        theme.palette.getContrastText(theme.palette.primary.main)
      )}" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/></svg>')`,
      left: 12,
    },
    '&:after': {
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
        theme.palette.getContrastText(theme.palette.primary.main)
      )}" d="M19,13H5V11H19V13Z" /></svg>')`,
      right: 12,
    },
  },
  '& .MuiSwitch-thumb': {
    boxShadow: 'none',
    width: 16,
    height: 16,
    margin: 2,
  },
}));

export default function ClanKerovi(props) {
  const [isopen, setIsOpen] = useState(false);

  const [open, setOpen] = useState(null);

  const [page, setPage] = useState(0);

  const [order, setOrder] = useState('asc');

  const [members, setMembers] = useState([]);

  const [id, setId] = useState(0);

  const [deviceid, setDeviceId] = useState(0);

  const [orderBy, setOrderBy] = useState('id');

  const [filterName] = useState('');

  const [rowsPerPage, setRowsPerPage] = useState(5);

  const [showdogcreate, setShowDogCreate] = useState(false);

  const forceUpdate = useForceUpdate();

  const SERVER_URL = process.env.REACT_APP_BACKEND_SERVER_URL;

  const handleChange = (event, id) => {
    const array = members;

    const objectWithSpecificId = array.find((obj) => obj.id === id);

    axios
      .put(`${SERVER_URL}/devices/${id}`, {
        aktivan: !objectWithSpecificId.aktivan,
      })
      .then(() => {
        objectWithSpecificId.aktivan = !objectWithSpecificId.aktivan;

        setMembers(array);
        forceUpdate();
      });
  };

  const handleRefresh = () => {
    setShowDogCreate(!showdogcreate);
    refreshData();
  };

  function refreshData() {
    const url = `${SERVER_URL}/devices?subscriberId=${props.vlasnik}`;

    fetch(url)
      .then((res) => res.json())
      .then((json) => {
        setId(props.vlasnik);
        setMembers(json);
        // Novi vlasnik ili osvježeni podaci: vrati na prvu stranicu ako trenutna više ne postoji
        setPage((p) => (p * rowsPerPage >= json.length ? 0 : p));
      });
  }

  if (id !== props.vlasnik) refreshData();

  const setData = (data) => {
    const {
      id,
      subscriberId,
      subscriber,
      ime,
      tip,
      IMEI,
      tiptrackera,
      brojmobitela,
      bojaputanje,
      uploadinterval,
      needreset,
      workmode,
      setuploadinterval,
      blokiran,
      datumstart,
      datumend,
      datumlast,
      brojlokacija,
    } = data;

    localStorage.setItem('id', id);
    localStorage.setItem('subscriberId', subscriberId);
    localStorage.setItem('subscriberime', subscriber.ime);
    localStorage.setItem('subscriberprezime', subscriber.prezime);
    localStorage.setItem('subscribermjesto', subscriber.mjesto);
    localStorage.setItem('subscriberdrzava', subscriber.drzava);
    localStorage.setItem('ime', ime);
    localStorage.setItem('tip', tip);
    localStorage.setItem('IMEI', IMEI);
    localStorage.setItem('tiptrackera', tiptrackera);
    localStorage.setItem('brojmobitela', brojmobitela);
    localStorage.setItem('bojaputanje', bojaputanje);
    localStorage.setItem('uploadinterval', uploadinterval);
    localStorage.setItem('needreset', needreset);
    localStorage.setItem('workmode', workmode);
    localStorage.setItem('setuploadinterval', setuploadinterval);
    localStorage.setItem('blokiran', blokiran);
    localStorage.setItem('datumstart', datumstart);
    localStorage.setItem('datumend', datumend);
    localStorage.setItem('datumlast', datumlast);
    localStorage.setItem('brojlokacija', brojlokacija);
  };

  const handleClickDelete = (event, id) => {
    setDeviceId(id);
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  const handleNo = () => {
    setIsOpen(false);
  };

  const handleYes = () => {
    DeleteDevice(deviceid);
    setIsOpen(false);
  };

  const DeleteDevice = (deviceid) => {
    axios.delete(`${SERVER_URL}/devices/${deviceid}`, {}).then(() => {
      refreshData();
    });
  };

  const handleCloseMenu = () => {
    setOpen(null);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - members.length) : 0;

  const filteredUsers = applySortFilter(members, getComparator(order, orderBy), filterName);

  const isNotFound = !filteredUsers.length && !!filterName;

  const ukupnoKolona = TABLE_HEAD.length;

  return (
    <>
      <Helmet>
        <title> GPS Dogs Tracking System </title>
      </Helmet>

      <Dialog
        open={isopen}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Brisanje uređaja</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">Da li ste sigurni?</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleNo}>Ne</Button>
          <Button onClick={handleYes} autoFocus>
            Da
          </Button>
        </DialogActions>
      </Dialog>

      <Container maxWidth={false}>
        <Button onClick={() => setShowDogCreate(!showdogcreate)}>Dodaj uređaj</Button>
        {showdogcreate && <HunterForDog hunterId={props.vlasnik} handler={handleRefresh} className="child" />}

        <Card>
          {members.length > 0 ? (
            <>
            <Scrollbar>
              <TableContainer sx={{ minWidth: 800 }}>
                <Table>
                  <UserListHead order={order} orderBy={orderBy} headLabel={TABLE_HEAD} onRequestSort={handleRequestSort} />
                  <TableBody>
                    {filteredUsers.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                      const {
                        id,
                        ime,
                        tip,
                        IMEI,
                        tiptrackera,
                        aktivan,
                        online,
                        onlinetoday,
                        datumend,
                        saldo,
                        datumlast,
                        subscriber,
                        subscriberId,
                      } = row;

                      const vlasnikId = subscriberId ?? subscriber?.id;

                      return (
                        <TableRow hover key={id} tabIndex={-1}>
                          <TableCell component="th" scope="row">
                            <Typography variant="subtitle2" noWrap>
                              {id}
                            </Typography>
                          </TableCell>

                          <TableCell>
                            <Stack direction="row" alignItems="center" spacing={2}>
                              <Avatar
                                alt={ime}
                                src={tip ? `/assets/images/lovackipsi/icon_${tip}.png` : undefined}
                                sx={{ width: 50, height: 50 }}
                                variant="rounded"
                              >
                                <Iconify icon="mdi:paw" width={28} />
                              </Avatar>
                              <Avatar
                                alt={tiptrackera}
                                src={
                                  tiptrackera
                                    ? `/assets/images/trackers/icon_${tiptrackera.toLowerCase()}.png`
                                    : undefined
                                }
                                sx={{ width: 30, height: 30 }}
                                variant="rounded"
                              >
                                <Iconify icon="mdi:crosshairs-gps" width={18} />
                              </Avatar>
                            </Stack>
                          </TableCell>

                          <TableCell align="left">
                            {subscriber && vlasnikId ? (
                              <Typography
                                component={Link}
                                to={`${VLASNIK_URL}?vlasnik=${vlasnikId}`}
                                variant="subtitle2"
                                noWrap
                                sx={{
                                  color: 'primary.main',
                                  textDecoration: 'none',
                                  '&:hover': { textDecoration: 'underline' },
                                }}
                              >
                                {subscriber.ime} {subscriber.prezime}
                              </Typography>
                            ) : (
                              <Typography variant="subtitle2" noWrap>
                                {subscriber?.ime} {subscriber?.prezime}
                              </Typography>
                            )}
                          </TableCell>

                          <TableCell align="left">
                            <Typography variant="subtitle2" noWrap>
                              {ime}
                            </Typography>
                          </TableCell>

                          <TableCell align="left">
                            <Typography variant="subtitle2" noWrap>
                              {tiptrackera}
                            </Typography>
                          </TableCell>

                          <TableCell align="left">
                            <Typography variant="subtitle2" noWrap>
                              {IMEI}
                            </Typography>
                          </TableCell>

                          <TableCell align="left">
                            <Checkbox
                              color="success"
                              checked={Boolean(aktivan)}
                              onChange={(event) => handleChange(event, id)}
                              inputProps={{ 'aria-label': 'controlled' }}
                            />
                          </TableCell>

                          <TableCell>
                            <FormControlLabel control={<Android12Switch checked={Boolean(online)} />} label="" />
                          </TableCell>

                          <TableCell>
                            <FormControlLabel control={<Android12Switch checked={Boolean(onlinetoday)} />} label="" />
                          </TableCell>

                          <TableCell align="left">
                            <Typography variant="subtitle2" noWrap>
                              {datumlast}
                            </Typography>
                          </TableCell>

                          <TableCell align="left">
                            <Typography variant="subtitle2" noWrap>
                              {datumend}
                            </Typography>
                          </TableCell>

                          <TableCell align="left">
                            <Typography variant="subtitle2" noWrap>
                              {saldo}
                            </Typography>
                          </TableCell>

                          <TableCell>
                            <Link to="/SLOBiHDogs/update">
                              <Button onClick={() => setData(row)}>Update</Button>
                            </Link>
                          </TableCell>

                          <TableCell>
                            <Link to="/SLOBiHDogs/sharedevice">
                              <Button onClick={() => setData(row)}>Share</Button>
                            </Link>
                          </TableCell>

                          <TableCell>
                            <Link to="/SLOBiHDogs/transferdevice">
                              <Button onClick={() => setData(row)}>Transfer</Button>
                            </Link>
                          </TableCell>

                          <TableCell>
                            <Button color="error" onClick={(event) => handleClickDelete(event, id)}>
                              Delete
                            </Button>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                    {emptyRows > 0 && (
                      <TableRow style={{ height: 53 * emptyRows }}>
                        <TableCell colSpan={ukupnoKolona} />
                      </TableRow>
                    )}
                  </TableBody>

                  {isNotFound && (
                    <TableBody>
                      <TableRow>
                        <TableCell align="center" colSpan={ukupnoKolona} sx={{ py: 3 }}>
                          <Paper sx={{ textAlign: 'center' }}>
                            <Typography variant="h6" paragraph>
                              Nema rezultata
                            </Typography>
                            <Typography variant="body2">
                              Ništa nije pronađeno za &nbsp;
                              <strong>&quot;{filterName}&quot;</strong>.
                            </Typography>
                          </Paper>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
            </Scrollbar>

            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={filteredUsers.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
            </>
          ) : (
            <div>
              <br /> Nema kerova
            </div>
          )}
        </Card>
      </Container>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 1,
            width: 140,
            '& .MuiMenuItem-root': {
              px: 1,
              typography: 'body2',
              borderRadius: 0.75,
            },
          },
        }}
      >
        <MenuItem>
          <Iconify icon={'eva:edit-fill'} sx={{ mr: 2 }} />
          Edit
        </MenuItem>

        <MenuItem sx={{ color: 'error.main' }}>
          <Iconify icon={'eva:trash-2-outline'} sx={{ mr: 2 }} />
          Delete
        </MenuItem>
      </Popover>
    </>
  );
}